
import React, { Component } from 'react';
import { PlusOutlined, RightOutlined } from '@ant-design/icons';
import { Input, Button, Checkbox, message } from "antd";
import output from "../../../imgs/item/output.png";
import { meshLog } from "../../../utils/spUtils";
import './energyHotPage.less';

export default class EnergyHotPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedValue: "item1", //item1  item2
        };
    }

    handleRadioChangeItem1 = (e) => {
        this.setState({
            selectedValue: "item1",
        })
        this.props.onDataToParent("0");
    };
    handleRadioChangeItem2 = (e) => {
        this.setState({
            selectedValue: "item2",
        })
        this.props.onDataToParent("1");
    };

    sendDataToParent() {
        this.props.onDataToParent("");
    };

    render() {
        const { selectedValue } = this.state;
        return (
            <div className="hot_container">
                {/* 1. Area Management 标题行 */}
                <div className="hot-row">
                    <div className="hot-title">
                        <img className='icon' src={output} />
                        <span>Heat Map Mode Selection</span>
                    </div>
                    {/* <InfoCircleOutlined className="header-icon" /> */}
                </div>

                {/* 单选框 */}
                <div className='item1Bg'>
                    <div className="item-title">
                        <span>Sensor Detection Count</span>
                        <input className="radioSet" type='radio' name='select' value='' style={{accentColor:'#FFBD27'}} checked={selectedValue == "item1"} onChange={this.handleRadioChangeItem1} />
                    </div>
                </div>

                <div className='item2Bg'>
                    <div className="item-title">
                        <span>Power Consumption</span>
                        <input className="radioSet" type='radio' name='select' value='' style={{accentColor:'#FFBD27'}} checked={selectedValue == "item2"} onChange={this.handleRadioChangeItem2} />
                    </div>
                </div>

                {/* 内容 */}
                <div className='hotInfoBg'>
                    <span className='title'>Color Description for Distribution</span>
                    <div className="hot1">
                        <div className='color'></div>
                        <span>Red indicates high</span>
                    </div>
                    <div className="hot2">
                        <div className='color'></div>
                        <span>Yellow indicates medium</span>
                    </div>
                    <div className="hot3">
                        <div className='color'></div>
                        <span>Blue indicates low</span>
                    </div>
                </div>


                {/* 底部按钮 */}
                <div className="hot-footer">
                    <button className='cancelBtn' onClick={this.sendDataToParent.bind(this)}>Cancel</button>
                    <button className='okBtn' onClick={this.sendDataToParent.bind(this)}>Confirm</button>
                </div>
            </div>
        );
    }
}
